import { useId, useState, type ReactNode } from 'react';
import { Icon } from './icon';

/**
 * A collapsible card section (card + chevron + local open state). Used for the ticket-details
 * receipt (open by default) and terms & conditions (collapsed by default).
 */
export function Accordion({
  title,
  subtitle,
  children,
  defaultOpen = false,
}: {
  title: string;
  subtitle?: string;
  children: ReactNode;
  defaultOpen?: boolean;
}) {
  const [open, setOpen] = useState(defaultOpen);
  const bodyId = useId();
  return (
    <div className="wb-card wb-card--pad wb-col wb-gap-12">
      <button
        type="button"
        className="wb-row wb-between"
        aria-expanded={open}
        aria-controls={bodyId}
        onClick={() => setOpen((o) => !o)}
        style={{
          background: 'none',
          border: 0,
          padding: 0,
          margin: 0,
          width: '100%',
          alignItems: 'center',
          cursor: 'pointer',
          textAlign: 'left',
          color: 'inherit',
        }}
      >
        <span className="wb-col wb-gap-4">
          <span className="wb-h3">{title}</span>
          {subtitle && <span className="wb-tiny">{subtitle}</span>}
        </span>
        <Icon name={open ? 'chevronUp' : 'chevronDown'} size={20} />
      </button>
      {open && (
        <div id={bodyId} className="wb-col wb-gap-10">
          {children}
        </div>
      )}
    </div>
  );
}
